var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gant-travel-container",staticStyle:{"background-image":"url('/images/gant-background.jpeg')"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }